// extracted by mini-css-extract-plugin
export default {"badge":"components-hotel-channel-pricing-tables-cells-pms-table-td-pms-table-name-cell-module__badge"};